//
import chroma from "chroma-js"

export const getChartsColorList = (colors) => {
    const newColors = chroma.scale(colors).mode('lch').colors(6)
    return newColors
}
